import moduleName from '../services/module-name';

const uxMapping = {};
uxMapping[moduleName.ABOUT_DESCRIPTION_V2] = 'StrAboutDescription';
uxMapping[moduleName.ABOUT_STORE_POLICIES] = 'StrAboutPolicies';
uxMapping[moduleName.ABOUT_VIDEO] = 'StrAboutVideo';
uxMapping[moduleName.BUSINESS_DETAILS] = 'StrBusinessDetails';
uxMapping[moduleName.CONTACT_SELLER] = 'StrContactSeller';
uxMapping[moduleName.ITEMS_CAROUSEL] = 'StrItemsCarousel';
uxMapping[moduleName.ITEMS_GRID] = 'StrItemsGrid';
uxMapping[moduleName.MARKETING_BANNER] = 'StrMarketingBanner';
uxMapping[moduleName.NAVIGATION_CAROUSEL] = 'StrItemsCarousel';
uxMapping[moduleName.NAVIGATION_CAROUSEL_V2] = 'StrItemsCarousel';
uxMapping[moduleName.SEEK_SURVEY_WEB] = 'StrSurvey';
uxMapping[moduleName.SELLER_COMMS] = 'StrSellerComms';
uxMapping[moduleName.STATUS_MESSAGE] = 'StrStatusModule';
uxMapping[moduleName.STORE_CATEGORIES] = 'StrCategories';
uxMapping[moduleName.STORE_CATEGORIES_V2] = 'StrCategories';

export const uxComponentsMapping = uxMapping;

export const regionMapping = {
    TOP: 'MAIN'
};

export const responseMapping = {
    seoMetaData: 'SEO_METADATA_MODEL'
};

export const genFlatModule = (module, uxComponent, isSmall, debug, draft) => ({
    ...module,
    _uxComponent: uxComponentsMapping[uxComponent],
    isSmall: isSmall,
    __debug: debug,
    __draft: draft
});

const defaultErrorMsg = (message) => ({
    _type: 'StatusMessageModule',
    message: {
        title: {
            _type: 'TextualDisplay',
            textSpans: [
                {
                    '_type': 'TextSpan',
                    'text': message
                }
            ]
        },
        messageType: 'ERROR',
        displayIcon: true
    },
    meta: {
        name: 'STATUS_MESSAGE'
    },
    _uxComponent: 'StrStatusModule'
});

export const defaultErrorMessages = {
    'en-US': defaultErrorMsg('There seems to be a problem serving the request at this time'),
    'de-DE': defaultErrorMsg('Leider ist bei dieser Anfrage momentan ein Problem aufgetreten')
};
